import { useEffect, useRef } from 'react';

export const IndeterminateCheckbox = (
  props: React.InputHTMLAttributes<HTMLInputElement> & { indeterminate?: boolean },
) => {
  const { indeterminate, ...rest } = props;
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = !!indeterminate;
  }, [indeterminate]);
  return <input ref={ref} type="checkbox" {...rest} />;
};

export default IndeterminateCheckbox;
